import React, { useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { useNavigate } from "react-router";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ViewListIcon from "@mui/icons-material/ViewList";
import SavingsIcon from "@mui/icons-material/Savings";
import BallotIcon from "@mui/icons-material/Ballot";
import ConfirmModal from "../../components/ConfirmModal";
import SellIcon from "@mui/icons-material/Sell";
import { fetchOnlyData } from "../../utility/adminApi";
import { useQuery } from "@tanstack/react-query";
import EditReceiptTemplate from "./EditReceiptTemplate";
import PaymentsIcon from "@mui/icons-material/Payments";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import NavLinker from "../../components/NavLinker";
import { OnlinePrediction } from "@mui/icons-material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

function SideBar() {
  const [isDropdownLowStock, setDropdownLock] = useState(false);
  const [isDropdownSales, setDropdownSales] = useState(false);
  const [isDropdownCustomer, setDropdownCustomer] = useState(false);
  const [isDropdownExpenses, setDropdownExpenses] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    data: template,
  } = useQuery({
    queryKey: ["admintemplate"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("receipt-template"),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    // Keep previous data during page changes
  });

  const handleQuit = () => {
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const navigate = new useNavigate();
  const handleConfirmQuit = () => {
    sessionStorage.clear();

    navigate("/login");
  };
  const handleDropdownLowStock = () => {
    setDropdownLock(!isDropdownLowStock);
  };

  const handleDropdownSales = () => {
    setDropdownSales(!isDropdownSales);
  };

  const handleDropdownCustomer = () => {
    setDropdownCustomer(!isDropdownCustomer);
  };

  const handleDropdownExpenses = () => {
    setDropdownExpenses(!isDropdownExpenses);
  };

  return (
    <div className="w-2/12  flex gap-2   flex-col px-4 pt-4 lg:pt-4 overflow-y-scroll pb-20 bg-gray-200">
      {/* <NavLink
       
        className="flex flex-row gap-2 hover:bg-[#629FF4]  hover:text-white rounded-md p-2 items-center"
      >
        <span className="text-base font-medium hidden lg:block">Dashboard</span>
      </NavLink> */}
      <NavLinker to="/admin" end>
        <HomeIcon />
        <span className="text-base font-medium hidden lg:block">Home</span>
      </NavLinker>
      <NavLinker to="reports">
        <AnalyticsIcon />
        <span className="text-base font-medium hidden lg:block">Reports</span>
      </NavLinker>

      <NavLinker to="products">
        <ViewListIcon />
        <span className="text-base font-medium hidden lg:block">Products</span>
      </NavLinker>

      <NavLinker to="addproduct">
        <AddIcon />
        <span className="text-base font-medium hidden lg:block">
          Add Products
        </span>
      </NavLinker>

      <NavLinker to="category">
        <BallotIcon />
        <span className="text-base font-medium hidden lg:block">My Store</span>
      </NavLinker>
      {/* <div>
        <button
          onClick={() => handleDropdown()}
          className="flex flex-row gap-2 hover:bg-[#629FF4]  hover:text-white rounded-md p-2 items-center"
        >
          <CategoryIcon />
          <span className="text-base font-medium hidden lg:block">Category</span>
          {isDropdown === false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        </button>
        {isDropdown && (
          <div className="pl-4">
            <NavLinker to="category">
              <BallotIcon />
              <span className="text-base font-medium hidden lg:block">
                Category
              </span>
            </NavLinker>
            <NavLinker to="subcategory">
              <ClearAllIcon />
              <span className="text-base font-medium hidden lg:block">
                Sub-Category
              </span>
            </NavLinker>
          </div>
        )}
      </div> */}

      <div>
        <button
          onClick={() => handleDropdownLowStock()}
          className="flex flex-row gap-2 hover:bg-[#629FF4]  hover:text-white rounded-md p-2 items-center"
        >
          <ShowChartIcon />
          <span className="text-base font-medium hidden lg:block">
            Low Stock
          </span>
          {isDropdownLowStock === false ? (
            <ArrowDropDownIcon />
          ) : (
            <ArrowDropUpIcon />
          )}
        </button>
        {isDropdownLowStock && (
          <div className="pl-4">
            <NavLinker to="lowstock">
              <ShowChartIcon />
              <span className="text-base font-medium hidden lg:block">
                Low Stock
              </span>
            </NavLinker>
            <NavLinker to="restock-pro">
              <TrendingUpIcon />
              <span className="text-base font-medium hidden lg:block">
                Restock Pro
              </span>
            </NavLinker>
          </div>
        )}
      </div>
      <div>
        <button
          onClick={() => handleDropdownSales && handleDropdownSales()}
          className="flex flex-row gap-2 hover:bg-[#629FF4]  hover:text-white rounded-md p-2 items-center"
        >
          <MonetizationOnIcon />
          <span className="text-base font-medium hidden lg:block">Sales</span>
          {isDropdownSales === false ? (
            <ArrowDropDownIcon />
          ) : (
            <ArrowDropUpIcon />
          )}
        </button>
        {isDropdownSales && (
          <div className="pl-4">
            <NavLinker to="sales">
              <MonetizationOnIcon />
              <span className="text-base font-medium hidden lg:block">
                Sales
              </span>
            </NavLinker>
            <NavLinker to="orders">
              <PermIdentityIcon />
              <span className="text-base font-medium hidden lg:block">
                Orders
              </span>
            </NavLinker>
          </div>
        )}
      </div>
      <NavLinker to="queued-orders">
        <PendingActionsIcon />
        <span className="text-base font-medium hidden lg:block">Queue</span>
      </NavLinker>
      <div>
        <button
          onClick={() => handleDropdownCustomer && handleDropdownCustomer()}
          className="flex flex-row gap-2 hover:bg-[#629FF4]  hover:text-white rounded-md p-2 items-center"
        >
          <PermIdentityIcon />
          <span className="text-base font-medium hidden lg:block">
            Customers
          </span>
          {isDropdownCustomer === false ? (
            <ArrowDropDownIcon />
          ) : (
            <ArrowDropUpIcon />
          )}
        </button>
        {isDropdownCustomer && (
          <div className="pl-4">
            <NavLinker to="customers">
              <PermIdentityIcon />
              <span className="text-base font-medium hidden lg:block">
                Customers
              </span>
            </NavLinker>
            <NavLinker to="invoice">
              <MonetizationOnIcon />
              <span className="text-base font-medium hidden lg:block">
                Invoices
              </span>
            </NavLinker>
          </div>
        )}
      </div>
      <div>
        <button
          onClick={handleDropdownExpenses}
          className="flex flex-row gap-2 hover:bg-[#629FF4]  hover:text-white rounded-md p-2 items-center"
        >
          <SellIcon />
          <span className="text-base font-medium hidden lg:block">
            Expenses
          </span>
          {isDropdownExpenses === false ? (
            <ArrowDropDownIcon />
          ) : (
            <ArrowDropUpIcon />
          )}
        </button>
        {isDropdownExpenses && (
          <div className="pl-4">
            <NavLinker to="expenses">
              <SellIcon />
              <span className="text-base font-medium hidden lg:block">
                Expenses
              </span>
            </NavLinker>
            <NavLinker to="bill">
              <BallotIcon />
              <span className="text-base font-medium hidden lg:block">
                Bill
              </span>
            </NavLinker>
          </div>
        )}
      </div>
      <NavLinker to="loyalty">
        <SavingsIcon />
        <span className="text-base font-medium hidden lg:block">Discount</span>
      </NavLinker>
      <NavLinker to="loan">
        <AssuredWorkloadIcon />
        <span className="text-base font-medium hidden lg:block">Loan</span>
      </NavLinker>
      {/* <NavLinker to="bill">
        <SellIcon />
        <span className="text-base font-medium hidden lg:block">Bill</span>
      </NavLinker> */}
      <NavLinker to="users">
        <PeopleOutlineIcon />
        <span className="text-base font-medium hidden lg:block">Users</span>
      </NavLinker>
      <NavLinker to="payment-method">
        <PaymentsIcon />
        <span className="text-base font-medium hidden lg:block">
          Payment Method
        </span>
      </NavLinker>
      <NavLinker to="online">
        <OnlinePrediction />
        <span className="text-base font-medium hidden lg:block">
          Online Store
        </span>
      </NavLinker>

      <button
        onClick={handleQuit}
        className="flex flex-row items-center gap-2 text-red-500 hover:text-red-600 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-red-400 transition-all"
      >
        <ExitToAppIcon sx={{ fontSize: 32 }} />
        <span className="text-[0.9rem] font-medium">Sign Out</span>
      </button>
      {viewModal && (
        <EditReceiptTemplate template={template} setViewModal={setViewModal} />
      )}
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmQuit}
        text1="Confirm Quit"
        text2="Are you sure you want to quit the app?"
      />
    </div>
  );
}

export default SideBar;
